import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockBottle extends ScrollItem__BlockDefault {
    hasHiddenEnabled = false;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('BlockBottle', ScrollItem__BlockBottle);

export default ScrollItem__BlockBottle;
